var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from 'mobx';
import ProfileAPI from './../services/ProfileAPI';
import SearchAPI from './../services/SearchAPI';
import { transformDealerUserList } from '../framework/DataTransformers';
import { DEALER_USERS_LIMIT } from '../framework/constants/profile';
import { ShowNotificationError } from '../framework/ErrorLogger';
class DealerProfileStore {
    constructor() {
        Object.defineProperty(this, "isFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProcessing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "userList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "userData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "totalUsers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "totalPages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "carViewsAggregationData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "getDealerUserList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (page, search) => {
                ProfileAPI.getDealerUserList(page, DEALER_USERS_LIMIT, search)
                    .then((result) => {
                    const { users: { items, search } } = result;
                    const usersArr = items || [];
                    this.userList = transformDealerUserList(usersArr);
                    const totalPagesModule = search.hits % search.limit;
                    const totalPagesInteger = Math.floor(search.hits / search.limit);
                    this.totalPages = totalPagesModule ? totalPagesInteger + 1 : totalPagesInteger;
                    this.totalUsers = parseInt(search.hits, 10);
                })
                    .catch(() => {
                    ShowNotificationError('errors.loadEmployees');
                });
            }
        });
        Object.defineProperty(this, "getDealerUserData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => ProfileAPI.getDealerUserData(id)
        });
        Object.defineProperty(this, "createDealerUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (formsValues) => {
                this.isProcessing = true;
                const userData = formatUserDataObject(formsValues);
                return ProfileAPI.createDealerUser(userData)
                    .then(() => {
                    this.isProcessing = false;
                    return userData;
                })
                    .catch(() => {
                    this.isProcessing = false;
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "editDealerUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id, formsValues) => {
                this.isProcessing = true;
                const userData = formatUserDataObject(formsValues);
                return ProfileAPI.editDealerUser(id, userData)
                    .then(() => {
                    this.isProcessing = false;
                    return userData;
                })
                    .catch(() => {
                    this.isProcessing = false;
                    ShowNotificationError();
                });
            }
        });
        Object.defineProperty(this, "deleteDealerUser", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (id) => ProfileAPI.deleteDealerUser(id)
        });
        Object.defineProperty(this, "clearUserList", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.userList = observable([]);
                this.totalUsers = 0;
                this.totalPages = 0;
            }
        });
        makeObservable(this);
    }
    getCarViewsAggregationData(dateFrom, dateTo, aggMode) {
        this.isFetching = true;
        return SearchAPI.getCarViewsAggregationData(dateFrom, dateTo, aggMode)
            .then((response) => {
            this.carViewsAggregationData = response.daysHours;
            this.isFetching = false;
        })
            .catch(() => {
            this.isFetching = false;
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "isFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "isProcessing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "userList", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "userData", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "totalUsers", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "totalPages", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DealerProfileStore.prototype, "carViewsAggregationData", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "getDealerUserList", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "getDealerUserData", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "createDealerUser", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "editDealerUser", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "deleteDealerUser", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], DealerProfileStore.prototype, "clearUserList", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String, String]),
    __metadata("design:returntype", void 0)
], DealerProfileStore.prototype, "getCarViewsAggregationData", null);
const formatUserDataObject = (formsValues) => {
    const isDadmin = formsValues.isDadmin ? ['isDadmin'] : [];
    const isDacc = formsValues.isDacc ? ['isDacc'] : [];
    const password = formsValues.password ? { password: formsValues.password } : {};
    const userObject = {
        email: formsValues.email,
        userAddress: {
            // BE still work on this fields
            // UPDATE EDIT SCREEN as well, so it can get this field from user data
            gender: formsValues.gender,
            title: formsValues.title,
            firstName: formsValues.firstName,
            lastName: formsValues.lastName,
            phoneMain: formsValues.landline,
            phoneMobile: formsValues.mobilephone,
            fax: formsValues.fax
        },
        ...password
    };
    return {
        user: userObject,
        roles: [...isDadmin, ...isDacc]
    };
};
export default new DealerProfileStore();
